
































































import _ from 'lodash'
import { Icon } from '@alpha/ink'
import icoLookup from '@/utilities/ico-lookup'
import ExistingAssetPicker from './ExistingAssetPicker.vue'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as db from '@shared/types/database'
import S3Assets from '@/api/S3Assets'

@Component({
  components: {
    Icon,
    ExistingAssetPicker
  }
})
export default class LinkComparison extends Vue {
  @Prop({ required: true }) readonly list!: Record<string, db.Prototype>
  @Prop({ default: () => ({}) }) readonly assets!: Record<string, db.Prototype>
  @Prop({ default: 1 }) readonly minLength!: number
  @Prop({ default: 4 }) readonly maxLength!: number
  @Prop({ default: false }) readonly editable!: boolean

  focused?: number

  isDisabled (url: string) {
    return S3Assets.urlIsFloopAsset(url)
  }

  get selectableAssets () {
    var that = this
    var k = _.pickBy(this.assets, function (value, key) {
      return value.url && _.every(that.list, function (chosenAsset, idx) {
        return idx !== key
      })
    })
    return k
  }

  get imageTypeMap () {
    return icoLookup
  }

  @Watch('editable', { immediate: true })
  editableUpdated () {
    if (this.editable && Object.keys(this.list).length === 0) {
      this.addOption() // start with one option, at least
    }
  }

  onFocus (index: number) {
    this.focused = index
  }

  onBlur (event: FocusEvent) {
    const els = this.$refs.proto as Element[]
    if (typeof this.focused === 'undefined') return
    const el = els[this.focused]
    if (!el.contains(event.relatedTarget as Element)) {
      this.focused = undefined
    }
  }

  selectExistingAsset (asset: db.Prototype, assetId: string) {
    var assetClone = Object.assign({}, asset)
    this.$set(this.list, assetId, assetClone)
    // Find if there's an empty one, and delete first one
    var emptyLinkKey = _.findKey(this.list, function (item) {
      return !item.title && !item.url
    })
    if (emptyLinkKey) {
      this.$delete(this.list, emptyLinkKey)
    }
  }

  openInNewWindow (asset: db.Prototype) {
    event && event.stopPropagation()
    let url = asset.url!
    if (!url.match(/^[a-zA-Z]+:\/\//)) {
      url = 'https://' + url
    }
    window.open(url)
  }

  clickItem (asset: db.Prototype) {
    if (!this.editable) {
      this.openInNewWindow(asset)
    }
  }

  addOption () {
    this.$emit('addOption')
  }

  removeOption (key: string) {
    var that = this
    this.$emit('removeOption', key)
    this.$nextTick(() => {
      if (Object.keys(that.list).length === 0) {
        that.addOption()
      }
    })
  }
}
